const LangModal = {
	"modal.button._confirm": ["Confirm", "បញ្ជាក់​"],
	"modal.button._ok": ["Ok", "យល់​ព្រម"],
	"modal.button._cancel": ["Cancel", "បោះបង់"],
	"modal.button._yes": ["Yes", "បាទ​/ ចាស"],
	"modal.button._no": ["No", "ទេ"],
	"modal.title._message": ["Message", "សារ"],
	"modal.button._next": ["Next", "Next"],
}

export default LangModal



// WEBPACK FOOTER //
// ./src/resources/modules/LangModal.js